// extracted by mini-css-extract-plugin
module.exports = {"root":"Features_root__3q1bV","inner":"Features_inner__39yVf"};